import React from 'react';
import { connect } from 'react-redux';
import { Card, CardBlock, CardTitle , Button ,DropdownItem , DropdownMenu , Nav , NavItem, Dropdown , DropdownToggle} from 'reactstrap';

import ReactTable from "react-table";
import "react-table/react-table.css";
import IconEdit from 'react-icons/lib/md/edit';
import IconPersonAdd from 'react-icons/lib/md/person-add';

import * as actions from '../../actions/movimientoalmacen';

import _ from "lodash";
import {api} from '../../actions/_request';

import Tabla from "./tabla";
import Movimiento from "./movimiento";
import Menu from '../facturacion/menu.js';

class Descuentos extends React.Component {

    constructor(props) {

        super(props);

        this.state = {
            formulario       : false,
            id : null,
            title       : "Entrada",
            tipo:1,

        };
        this.formulario       = this.formulario.bind(this);


    }
    formulario( id = null, title = "Entrada",tipo=1)
    {
        let {formulario} = this.state;

        this.setState({
            formulario       : !formulario,
            id : id,
            title       : title,
            tipo:tipo,
            
        });
    }

    componentDidMount() {

       // this.props.get();
    }

    render() {
     let {formulario} = this.state;
        return(
            <div className="view">
           <Menu props={this.props}/>
           {formulario==false?
            <Tabla formulario={this.formulario}/>:
            <Movimiento cerrar={this.formulario} 
                        title={this.state.title} 
                        id={this.state.id} 
                        tipo={this.state.tipo}/>}
           

            </div>
        );
    }

};

function mapStateToProps(state, ownProps) {
    return {
        movimientoalmacen : state.movimientoalmacen,
    }
};

export default connect(mapStateToProps, actions)(Descuentos)


// WEBPACK FOOTER //
// ./src/views/movimientosAlmacenes/index.js